import { Location } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalService,
  MSAL_GUARD_CONFIG
} from '@azure/msal-angular';
import { Observable, of } from 'rxjs';
import { AppConfig } from '../../config/app.config';

@Injectable()
export class MsalOptionalGuard extends MsalGuard {
  constructor(
    private appConfig: AppConfig,
    // tslint:disable-next-line: variable-name
    @Inject(MSAL_GUARD_CONFIG) private _msalGuardConfig: MsalGuardConfiguration,
    // tslint:disable-next-line: variable-name
    private _msalBroadcastService: MsalBroadcastService,
    // tslint:disable-next-line: variable-name
    private _authService: MsalService,
    // tslint:disable-next-line: variable-name
    private _location: Location,
    // tslint:disable-next-line: variable-name
    private _router: Router
  ) {
    super(
      _msalGuardConfig,
      _msalBroadcastService,
      _authService,
      _location,
      _router
    );
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const azureAD = this.appConfig.getAzureAD();
    if (azureAD.enabled) {
      return super.canActivate(route, state);
    }
    return of(true);
  }
}
